const AndroidPage = () => import('@/views/AndroidPage')

export default [
  {
    path: '/AndroidPage',
    component: AndroidPage,
    meta: { requireAuth: true }
  }
]
